import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
// import registerServiceWorker from './registerServiceWorker';

import 'jquery-backstretch/libs/jquery/jquery';
import 'jquery-backstretch/jquery.backstretch.min';
import 'flickity/dist/flickity.pkgd.min';

if (localStorage.siteLang === undefined) {
    if (navigator.language.substring(0, 2) === "ar") localStorage.siteLang = "ar";
    else localStorage.siteLang = "en";
}

ReactDOM.render(<App />, document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js